<template>
  <div>
    <span style="font-weight:bold">{{ value }}</span
    ><span style="font-size:.8em;opacity:.6" v-if="display">
      ({{ display }})</span
    >
  </div>
</template>

<script>
/**
 * this is to display the Name of a given lead (by id) and a link to the detail page
 */
import axios from "axios";
export default {
  name: "Postcode",
  props: {
    value: String
  },
  data() {
    return {
      display: null
    };
  },
  methods: {
    async getSuburbsByPostcode(post) {
      try {
        const response = await axios.get(
          `https://cors-anywhere.herokuapp.com/http://v0.postcodeapi.com.au/suburbs/${post.trim()}.json`
        );
        const data = response.data;
        // console.log(data);
        if (data && data.length) {
          let str = [];
          for (let i = 0; i < data.length; i++) {
            const d = data[i];
            str.push(d.name + ", " + d.state.abbreviation);
          }
          //   data.foreach((d) => {

          //   });
          this.display = str.join(" | ");
        } else {
          this.display = "No Suburb Found";
        }
      } catch (e) {
        // console.error(e);
        this.display = "";
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        this.getSuburbsByPostcode(v);
      }
    }
  }
};
</script>

<style></style>
